import { Base } from '@studiometa/js-toolkit';
import MenuItem from '../atoms/MenuItem.js';

/**
 * Toast component
 */
export default class Menu extends Base {
  currentPicture = '';
  imageNumber = 0;

  /**
   * Component Configuration
   */
  static config = {
    name: 'Menu',
    refs: ['item[]', 'pictureContainer', 'pictureDefaultContainer', 'close[]'],
    components: {
      MenuItem,
    },
  };

  /**
   * Mount component
   * @returns {void}
   */
  mounted() {
    this.defaultPicture = this.$refs.pictureContainer.src;
    this.currentItem = null;
  }

  /**
   * Hover item
   * @param {object} props Props
   * @param {object} props.target current element
   * @returns {void}
   */
  onItemMouseenter({ target }) {
    if (this.currentItem === target) {
      return;
    }

    this.currentItem = target;

    this.currentPicture = target.dataset.picture;
    this.createNewImage();
  }

  /**
   * Create new img element in container
   * @returns {void}
   */
  createNewImage() {
    if (this.imageNumber > 3) {
      this.flushImages();
    }
    const img = document.createElement('img');
    img.setAttribute('src', this.currentPicture ? this.currentPicture : this.defaultPicture);
    img.className =
      'absolute top-0 left-0 size-full object-center object-cover z-1 picture-added transition duration-300 z-1';
    img.setAttribute('alt', '');
    img.setAttribute('style', `z-index:${this.imageNumber}`);
    this.$refs.pictureContainer.insertBefore(img, this.$refs.pictureContainer.firstChild);
    this.imageNumber += 1;
  }

  /**
   * Remove old images
   * @returns {void}
   */
  flushImages() {
    const images = this.$refs.pictureContainer.querySelectorAll('img');

    images.forEach((element, index) => {
      if (index !== 0) {
        element.remove();
      }
    });
  }

  /**
   * Click on close btn
   * @returns {void}
   */
  onCloseClick() {
    this.closeMenu();
  }

  /**
   * Cloes the menu
   * @returns {void}
   */
  closeMenu() {
    document.documentElement.classList.remove('menu-open');
  }

  /**
   * Close panel when type on Escape key
   * @param {object} props Props
   * @param {object} props.ESC Escape key
   * @returns {void}
   */
  keyed({ ESC }) {
    if (ESC) {
      this.closeMenu();
    }
  }

  /**
   * Close last submenu when clicked on another submenu
   * @returns {void}
   */
  onMenuItemOpen() {
    this.$children.MenuItem.forEach((element) => {
      if (element.$options.depth === 2 && element.open === true) {
        element.closeSubmenu();
      }
    });
  }
}
